export default __webpack_public_path__ + "static/media/Connected.6ae78fb4.png";